export const trainerDetailsFormResources = {
  trainerDetails: "Trainer Details",
  firstnameRequired: "First name is required",
  lastnameRequired: "Last name is required",
  emailRequired: "Email is required",
  emailInvalid: "Not a valid email address",
};
